module.exports = __webpack_public_path__ + "img/finish-success.4334f884.svg";